module.exports = {
    /**
     * List of icons to apply per product type
     * for example, if you wanted to display a car for personal auto:
     *     PersonalAuto: 'mi-directions_car'
     */
    productTypeIcons: {},

    /**
     * List of icons to apply per line of business type
     * For example, if you wanted to specify a different icon where refering to
     * HOPHomeowners instead of Homeowners, you could do the following
     *     HOPHomeowners: 'mi-home',
     *     Homeowners: 'mi-tenant',
     */
    lobIcons: {},

    /**
     * Images that represent the product used
     * allows you to define different images to map to products
     * For example:
     *     QuickQuote: 'product_quickquote',
     *     WorkersComp: 'product_workerscomp'
     */
    productCodeImages: {},

    /**
     * Icons for specific policy types.
     * Would allow you to define different icons per policy types,
     * if you had multiple different policy types under one line
     * For example, a homeowners policy and renters policy could differ::
     *     HomeownersLine: 'mi-home',
     *     HomeownersLine_HOE: 'mi-tenant',
     */
    policyTypeIcons: {},
};
